import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/sino-system/param/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const cmsGetUrl = (params) => {
  return request({
    url: '/api/sino-system/param/cmsGetUrl',
    method: 'get',
    params: {
      ...params
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/sino-system/param/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/sino-system/param/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/sino-system/param/submit',
    method: 'post',
    data: row
  })
}
